import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum CommonBookingErrors {
    TOTAL_NIGHTS_LESS_THAN_MLOS = 'total-nights-less-than-mlos',
}

@Injectable({
    providedIn: 'root',
})
export class BookingConfigErrorsService {
    constructor(private translate: TranslateService) {}

    getCommonBookingTranslatedError(errorCode: CommonBookingErrors): string {
        return this.translate.instant('commonBookingErrors.' + errorCode);
    }
}
